import { useState, useCallback } from 'react';

export type ContextMenuState = {
    mouseX: number;
    mouseY: number;
    open: boolean;
};

export const useContextMenu = () => {
    const [contextMenu, setContextMenu] = useState<ContextMenuState>({
        mouseX: 0,
        mouseY: 0,
        open: false,
    });

    const openContextMenu = useCallback((event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();

        setContextMenu({
            mouseX: event.clientX,
            mouseY: event.clientY,
            open: true,
        });
    }, []);

    const closeContextMenu = useCallback(() => {
        setContextMenu((prev) => ({ ...prev, open: false }));
    }, []);

    return {
        contextMenu,
        openContextMenu,
        closeContextMenu,
    };
};
